import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-tooltip-widget',
  templateUrl: './tooltip-widget.component.html',
  styleUrls: ['./tooltip-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet],
})
export class TooltipWidgetComponent {
  private changeDetectionRef = inject(ChangeDetectorRef);

  @Input() text?: string;
  @Input() contentTemplate?: TemplateRef<unknown>;
  @Input() templateData: object | null = null;

  @Input() set showAboveTheParent(value: boolean) {
    this.showAbove = value;
    this.changeDetectionRef.detectChanges();
  }

  showAbove = false;
}
